import { get, post, remove} from "../common/http.services";

export function saveProcess(processModel: any, appContext: any, success: any, error: any) {
    return post(`/production/saveprocess`, processModel, appContext, success, error);
}

export function deleteProcess(processId: any, appContext: any, success: any, error: any) {
    return remove(`/production/deleteprocess?processId=${processId}`, appContext, success, error);
}

export function getProcess(pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/production/getprocess?page=${pageNumber}&size=${pageSize}&sort=process,asc`, appContext, success, error);
}

export function getProcessById(id: any, appContext: any, success: any, error: any) {
    return get(`/production/findprocessbyid?processId=${id}`, appContext, success, error);
}

export function searchSchedule(searchData: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return post(`/production/searchschedule?page=${pageNumber}&size=${pageSize}`, searchData, appContext, success, error);
}

export function saveSchedule(scheduleModel: any, appContext: any, success: any, error: any) {
    return post(`/production/saveschedule`, scheduleModel, appContext, success, error);
}

export function getScheduleById(id: any, appContext: any, success: any, error: any) {
    return get(`/production/findschedulebyid?id=${id}`, appContext, success, error);
}

export function getWorkFlow(costingId: any, appContext: any, success: any, error: any) {
    return get(`/production/getworkflow?costingId=${costingId}`, appContext, success, error);
}

export function getScheduleByOrderCode(orderCode: any, pageNumber: any, pageSize: any, appContext: any, success: any, error: any) {
    return get(`/production/findschedulebyordercode?orderCode=${orderCode}&page=${pageNumber}&size=${pageSize}`, appContext, success, error);
}

export function deleteSchedule(scheduleId: any, appContext: any, success: any, error: any) {
    return remove(`/production/deleteschedule?scheduleId=${scheduleId}`, appContext, success, error);
}
